import firebase from 'firebase'
import 'firebase/auth';
import 'firebase/firestore';
import {firebaseConfig} from "./firebaseConfig";


firebase.initializeApp(firebaseConfig);
firebase.analytics();
const auth = firebase.auth();
const db = firebase.firestore();

export {auth,db}
export default firebase;